import React, { useEffect } from "react";
import { usePromptStore } from "../store/promptStore";

interface ErrorViewProps {}

const ErrorView: React.FC<ErrorViewProps> = ({}) => {
  const error = usePromptStore((state) => state.error);

  useEffect(() => {
    if (error) {
      console.error(`Pluto Error: ${error.message} (${error.code})`);
    }
  }, [error]);

  return (
    <div className="relative h-full mt-4">
      <div className="flex flex-col items-center">
        <span className="text-xl font-medium">Something went wrong</span>
        <span className="text-md text-text-secondary mt-3">
          {error.display_message || "Please try again"}
        </span>
        <span className="text-sm text-text-secondary mt-4">
          Error {error.code}
        </span>
      </div>

      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
        <svg
          width="100"
          height="100"
          viewBox="0 0 100 100"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M50 25C36.2 25 25 36.2 25 50C25 63.8 36.2 75 50 75C63.8 75 75 63.8 75 50C75 36.2 63.8 25 50 25ZM50 52.5C48.625 52.5 47.5 51.375 47.5 50V40C47.5 38.625 48.625 37.5 50 37.5C51.375 37.5 52.5 38.625 52.5 40V50C52.5 51.375 51.375 52.5 50 52.5ZM52.5 62.5H47.5V57.5H52.5V62.5Z"
            fill="#FF4A39"
          />
          <circle cx="50" cy="50" r="50" fill="#E5553F" fill-opacity="0.1" />
        </svg>
      </div>
    </div>
  );
};

export default ErrorView;
